import { createContext, FC, PropsWithChildren } from "react";
import { IGlobalCache, useGlobalCache } from "../hooks/useGlobalCache";

export const globalCacheContext = createContext<IGlobalCache>({
    cacheRequest: () => {
    },
    getCachedRequest: () => {
    },
    getStorageItem: () => {
    },
    setStorageItem: () => {
    },
});

interface ICacheStorageProviderProps extends PropsWithChildren {
}

export const GlobalCacheProvider: FC<ICacheStorageProviderProps> = ({ children }) => {
    const cacheStorage = useGlobalCache();

    return <globalCacheContext.Provider value={cacheStorage}>
        {children}
    </globalCacheContext.Provider>;
};
